import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEnvelopeOpen = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-envelope-open';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.771 4.992c-2.292 1.577-4.169 2.884-4.17 2.903 0 .019.08.148.179.287s.18.272.18.295c0 .027-.131.043-.36.043h-.36v12.24h17.52V8.52h-.36c-.229 0-.36-.016-.36-.043 0-.023.081-.156.18-.295s.179-.268.179-.287c-.003-.049-8.308-5.753-8.391-5.763-.038-.005-1.944 1.282-4.237 2.86m7.559 1.209c1.798 1.237 3.27 2.261 3.269 2.274-.001.041-6.526 4.1-6.595 4.103-.08.003-6.606-4.066-6.592-4.111.017-.055 6.566-4.545 6.608-4.53a373 373 0 0 1 3.31 2.264m-9.044 4.613c.822.514 1.494.953 1.494.977 0 .038-2.728 2.999-2.935 3.185l-.085.076v-2.586c0-1.422.007-2.586.016-2.586s.689.42 1.51.934m12.954 1.667v2.601l-1.51-1.624c-.831-.893-1.51-1.643-1.51-1.667 0-.038 2.916-1.899 2.99-1.907.017-.002.03 1.166.03 2.597m-8.654 1.02c.755.472 1.392.859 1.414.859s.659-.387 1.414-.859a54 54 0 0 1 1.43-.877c.035-.011.88.871 2.226 2.321l2.17 2.339v1.956H4.76v-1.958l2.17-2.338c1.347-1.451 2.191-2.331 2.226-2.32.031.01.674.405 1.43.877"
    })
  }));
});
export default SvgEnvelopeOpen;